import {useAppContext} from "./useAppContext";
import {useProductRatingStatisticsFragment} from "./useProductRatingStatisticsFragment";

export const useProductRating = () => {
    const {ratingCount, ratingAverageGrade} = useAppContext();
    const {loading, model: {count, mean}} = useProductRatingStatisticsFragment();

    const displayCount = loading ? ratingCount ?? 0 : count;
    const displayGrade = loading ? ratingAverageGrade ?? 0 : mean;

    return {
        count: displayCount,
        grade: displayGrade
    }
}